import PropTypes from 'prop-types';
import React from 'react';
import Select, { components } from 'react-select';

function SelectComponent(_ref) {
  var options = _ref.options,
      value = _ref.value,
      onChange = _ref.onChange;

  if (!options) {
    return null;
  }

  var selectedOption = options.find(function (option) {
    return option.value === value;
  });
  return React.createElement(Select, {
    closeMenuOnSelect: true,
    components: components.SelectContainer,
    options: options,
    value: selectedOption,
    onChange: onChange
  });
}

SelectComponent.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.any
  })),
  value: PropTypes.any,
  onChange: PropTypes.func
};
export default SelectComponent;